export default __webpack_public_path__ + "static/illustration-content-title.url-88c35e0c142d4a4f641a775475ccdb47.svg";